module.exports = __webpack_public_path__ + "static/media/learning-26.76119029.png";